import VueQrcode from "vue-qrcode";
import directDebit from "@/services/modules/directDebit";

const PaymentIDTable = () =>
  import(
    "@/components/OperationsPage/Deposit/Rial/PaymentID/paymentIDTable/index"
  );

export default {
  name: "payment-id",
  components: { PaymentIDTable, VueQrcode },
  props: [],
  data() {
    return {
      gatewayChoose: null,
      gatewayList: []
    };
  },
  computed: {
    filteredGateways() {
      return this.gateways.filter(el => el.user_identifier === null);
    },
    filteredGeneratedGateways() {
      return this.gateways.filter(el => el.user_identifier !== null);
    }
  },
  mounted() {
    this.getGateways();
  },
  methods: {
    getGateways() {
      directDebit.getAllGateways().then(res => {
        this.gatewayList = res.data.data;
      });
    },
    cancelOrder() {
      this.$emit("changeMode", "firstSection");
    },
    nextPage() {
      localStorage.setItem("chooseItem", JSON.stringify(this.gatewayChoose));
      this.$emit("changeMode", "createContractForm");
    }
  }
};
